/* eslint camelcase: 0 */
import { Price } from '@/infrastructure/network/Monitaro/schema/models'
import { IPriceProps, EmptyPricePropsFactory } from '@/entities/Price'

export const toPriceProps = (props: Price | null | undefined): IPriceProps => {
  if (!props) {
    return EmptyPricePropsFactory()
  }

  const { id, name, fee, share, max, is_group, order, properties, created_at, updated_at } = props

  return EmptyPricePropsFactory({
    id,
    name,
    fee,
    share,
    max,
    isGroup: is_group,
    order,
    properties,
    createdAt: created_at,
    updatedAt: updated_at
  })
}
